export const SUBSCRIPTION_STATUS = Object.freeze({
    ACTIVE: 'active',
    TRIALING: 'trialing',
    INACTIVE: 'inactive',
    PAST_DUE: 'past_due',
    CANCELED: 'canceled'
});